// This file is auto-generated by dibs-icons script
import { type FC } from 'react';
import Medal20 from './Medal20';
import Medal20Filled from './Medal20Filled';
import Medal20Circle from './Medal20Circle';
import Medal24 from './Medal24';
import Medal24Filled from './Medal24Filled';
import Medal24Circle from './Medal24Circle';
import Medal40 from './Medal40';
import Medal40Filled from './Medal40Filled';
import Medal48 from './Medal48';
import Medal48Filled from './Medal48Filled';

type MedalProps = {
    variation:
        | '20'
        | '20Filled'
        | '20Circle'
        | '24'
        | '24Filled'
        | '24Circle'
        | '40'
        | '40Filled'
        | '48'
        | '48Filled';
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const svgVariations = {
    Medal20,
    Medal20Filled,
    Medal20Circle,
    Medal24,
    Medal24Filled,
    Medal24Circle,
    Medal40,
    Medal40Filled,
    Medal48,
    Medal48Filled,
};

const Medal: FC<MedalProps> = ({ variation, ...props }) => {
    const variationKey = `Medal${variation}` as keyof typeof svgVariations;
    const Icon = svgVariations[variationKey];

    if (!Icon) {
        // eslint-disable-next-line no-console
        console.error(`"Medal" icon variation ${variationKey} does not exist`);
        return null;
    }

    return <Icon {...props} />;
};

export default Medal;
